import { render, staticRenderFns } from "./papersList.vue?vue&type=template&id=b8843884&scoped=true&"
import script from "./papersList.vue?vue&type=script&lang=js&"
export * from "./papersList.vue?vue&type=script&lang=js&"
import style0 from "./papersList.vue?vue&type=style&index=0&id=b8843884&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8843884",
  null
  
)

export default component.exports